import { useThemesStore } from '../../store';

const useThemeComponents = () => {
  const { componentsConfig = {} } = useThemesStore();
  return componentsConfig;
};

export default useThemeComponents;
